import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-display-parent',
  templateUrl: './display-parent.component.html',
  styleUrls: ['./display-parent.component.css']
})
export class DisplayParentComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
